import { connection } from "./connection";

export default {
  getCustomer() {
    return connection.get("portal/customer");
  }
};
